import axios from "axios";

//Useristrator panel store module
const userModule = {
	namespaced: true,
	state: {
		userToken: "",
		user: {},
	},
	getters: {
		getToken: (state) => state.userToken,
		getUser: (state) => state.user,
	},
	mutations: {
		//Save token
		saveToken: (state, token) => {
			state.userToken = token;

			//Store it in the localStorage
			window.localStorage.setItem("userAuthToken", token);
			//And use it in future requests
			axios.defaults.headers.common["Authorization"] = token;
		},
		saveUser: (state, user) => {
			state.user = user;
		},
		removeToken: (state) => {
			state.userToken = "";

			window.localStorage.removeItem("userAuthToken");
			axios.defaults.headers.common["Authorization"] = "";
		},
	},
	actions: {
		//If the user logged in successfully, save token
		authSuccess: ({ commit, dispatch }, token) => {
			commit("saveToken", token);
			dispatch("fetchUser");
		},
		fetchUser: async ({ commit, state }) => {
			if (state.userToken !== "") {
				const response = await axios.get("/user");
				commit("saveUser", response.data);
			}
		},
		logoutSuccess: ({ commit }) => {
			commit("removeToken");
		},
	},
};

export default userModule;
